import cn from 'classnames';
import { priceFormater } from '@/settings/index';
import { priceFormatSuperscript } from '@/lib/price';
import i18n from '@/settings/i18n';

const t = i18n.init('product');

const AMOUNT_PLACEHOLDER = '@@AMOUNT@@';

const PriceSavingsBadge = ({
  savings,
  className,
}: {
  savings: number;
  className?: string;
}) => {
  const phrase = t`Save ${{ amount: AMOUNT_PLACEHOLDER }}`;
  const [before = '', after = ''] = phrase.split(AMOUNT_PLACEHOLDER);

  return (
    <span className={cn('flex items-center justify-center gap-1', className)}>
      {before.trim() && <span>{before.trim()}</span>}
      <span translate="no">
        {priceFormatSuperscript(priceFormater.long(savings))}
      </span>
      {after.trim() && <span>{after.trim()}</span>}
    </span>
  );
};

export default PriceSavingsBadge;
